<template>
  <p v-if="records.length > 1">{{ dictionary.modalExtrasRequiredGroupText }}</p>

  <ul class="b-extras-as-badges-list">
    <li v-for="(item, index) in records" :key="index">
      <ExtrasBadgeRequired
        :id="item"
        v-model="selected"
        :index="groupIndex"
        :options="options" />
    </li>
  </ul>
</template>

<script>
import ExtrasBadgeRequired from './ExtrasBadgeRequired.vue'

export default {
  components: { ExtrasBadgeRequired },
  props: {
    groupIndex: { required: true, type: Number },
    records: { required: true, type: Array },
    options: { required: true, type: Array },
    selectedOptions: { required: true, type: Array },
  },
  emits: ['change-selected'],
  data() {
    return {
      selected: '',
    }
  },
  watch: {
    selected(newValue, oldValue) {
      this.$emit('change-selected', newValue, oldValue)
    },
  },
  mounted() {
    this.setPreselectedValues()
  },
  methods: {
    setPreselectedValues() {
      // check if a records entry has been already been selected by user
      // if so, set it as preselected
      const entry = this.records.find((i) => this.selectedOptions.includes(i))
      this.selected = entry ? entry : this.records[0]
    },
  },
}
</script>
